export const DEFAULT_RESIZE_DEBOUNCE_TIME = 40;
